"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        title: "Enter your email",
        input: {
            placeholder: "Enter your email",
        },
        validation: {
            required: "This field is required",
            "wrong-email": "Invalid email format",
            "send-fail": "An error occurred. Please, try again",
        },
        button: "Send me the terms of the referral program",
    },
    ru: {
        title: "Введите вашу почту",
        input: {
            placeholder: "Введите вашу почту",
        },
        validation: {
            required: "Поле обязательно для заполнения",
            "wrong-email": "Неправильный формат",
            "send-fail": "Произошла ошибка. Попробуйте снова",
        },
        button: "Выслать условия реферальной программы",
    },
    uz: {
        title: "Emailingizni kiriting",
        input: {
            placeholder: "Elektron pochtangizni kiriting",
        },
        validation: {
            required: "Bu maydon shart",
            "wrong-email": "Format noto'g'ri",
            "send-fail": "Xatolik yuz berdi. Qayta urinib ko'ring",
        },
        button: "Yo'llanma dasturi shartlarini yuborish",
    },
    kz: {
        title: "Электрондық поштаңызды енгізіңіз",
        input: {
            placeholder: "Электрондық поштаңызды енгізіңіз",
        },
        validation: {
            required: "Бұл өрісті толтыру міндетті",
            "wrong-email": "Қате формат",
            "send-fail": "Қате орын алды. Қайтадан көріңіз",
        },
        button: "Реферальдық бағдарламаның шарттарын жіберу",
    }
};
